// Formatos y textos del CRM de setting (/admin/setting). Puro, sin red. Las fechas SIEMPRE en hora de Chile, sin
// importar la zona del navegador de quien mira.
const ZONA = 'America/Santiago';

export const ETAPAS = [
  { clave: 'por_abrir', etiqueta: 'Por abrir', trabajo: true },
  { clave: 'esperando', etiqueta: 'Esperando', trabajo: true },
  { clave: 'conversando', etiqueta: 'Conversando', trabajo: true },
  { clave: 'asesoria_ofrecida', etiqueta: 'Asesoría ofrecida', trabajo: true },
  { clave: 'agendo', etiqueta: 'Agendó', trabajo: false },
  { clave: 'mas_adelante', etiqueta: 'Más adelante', trabajo: false },
  { clave: 'no_califica', etiqueta: 'No califica', trabajo: false },
  { clave: 'con_agustin', etiqueta: 'Con Agustín', trabajo: false },
  { clave: 'sin_respuesta', etiqueta: 'Sin respuesta', trabajo: false },
];
export const etiquetaEtapa = (clave) => (ETAPAS.find((e) => e.clave === clave) || {}).etiqueta || clave;

export const ACCIONES = [
  { accion: 'agendo', etiqueta: 'Agendó' },
  { accion: 'no_califica', etiqueta: 'No califica' },
  { accion: 'mas_adelante', etiqueta: 'Más adelante' },
  { accion: 'a_agustin', etiqueta: 'Pasar a Agustín' },
  { accion: 'a_julio', etiqueta: 'Pasar a Julio' },
  { accion: 'reabrir', etiqueta: 'Reabrir' },
];
const ETIQUETA_ACCION = { ...Object.fromEntries(ACCIONES.map((a) => [a.accion, a.etiqueta])), nota: 'Nota' };
export const etiquetaAccion = (accion) => ETIQUETA_ACCION[accion] || accion;

const TRABAJO = new Set(ETAPAS.filter((e) => e.trabajo).map((e) => e.clave));
/** Las acciones que tienen sentido para este lead. Las demás la Bandeja las rechazaría con "Ya estaba así". */
export const accionesPara = (lead) => ACCIONES.filter(({ accion }) => {
  if (accion === 'a_agustin') return lead.dueno !== 'agustin';
  if (accion === 'a_julio') return lead.dueno === 'agustin';
  if (accion === 'reabrir') return !TRABAJO.has(lead.etapa) && lead.etapa !== 'con_agustin';
  return lead.etapa !== accion;
});

export const TEXTO_PENDIENTE = 'pendiente: la Bandeja lo aplica en la próxima vuelta';

const partes = (fecha, opciones) => {
  const d = fecha instanceof Date ? fecha : new Date(fecha);
  if (Number.isNaN(d.getTime())) return null;
  return Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: ZONA, hourCycle: 'h23', ...opciones })
    .formatToParts(d).map((p) => [p.type, p.value]));
};

export const fechaHora = (iso) => {
  const p = iso ? partes(iso, { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : null;
  return p ? `${p.day}-${p.month} ${p.hour}:${p.minute}` : '';
};
export const diaChile = (fecha = new Date()) => {
  const p = partes(fecha, { year: 'numeric', month: '2-digit', day: '2-digit' });
  return p ? `${p.year}-${p.month}-${p.day}` : '';
};
export const mananaChile = (ahora = new Date()) => diaChile(new Date(ahora.getTime() + 24 * 60 * 60 * 1000));
export const nombreDia = (dia, hoy) => {
  if (dia === hoy) return 'Hoy';
  const [y, m, d] = dia.split('-');
  return `${d}-${m}-${y}`;
};

export const haceTexto = (min) => {
  if (min === null || min === undefined) return '';
  if (min < 1) return 'recién';
  if (min < 60) return `hace ${min} min`;
  return `hace ${Math.floor(min / 60)} h`;
};
export const textoSync = (sync) => (sync && sync.ultima
  ? `Bandeja sincronizada ${haceTexto(sync.haceMin)}`
  : 'La Bandeja todavía no se ha sincronizado');

export const linkInstagram = (usuario) => `https://ig.me/m/${encodeURIComponent(usuario)}`;

const DESCRIPCION_EVENTO = {
  apertura: 'Julio abrió la conversación',
  respuesta: 'Julio respondió',
  seguimiento: 'Julio hizo un seguimiento',
  mensaje_agustin: 'Agustín escribió',
  respondio: 'Contestó',
  paso: 'Llegó a un paso nuevo',
  agendo: 'Agendó',
  no_califica: 'No califica',
  mas_adelante: 'Más adelante',
  a_agustin: 'Pasó a Agustín',
  reabierto: 'Se reabrió',
  nota: 'Nota',
};
export const textoEvento = (e) => [DESCRIPCION_EVENTO[e.tipo] || e.tipo, e.detalle].filter(Boolean).join(': ');

export const ultimoContacto = (lead) => [lead.ultimo_prospecto, lead.ultimo_au]
  .filter((x) => x && !Number.isNaN(Date.parse(x)))
  .sort((a, b) => Date.parse(b) - Date.parse(a))[0] || '';
